import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import InputField from "components/form/InputField";
import SelectField from "components/form/SelectField";
import TextAreaField from "components/form/TextAreaField";
import DateField from "components/form/DateField";
import FormActionButtons from "components/Button/FormActionButtons";
import KodeKaryawanInput from "components/form/KodeKaryawanInput";
import PasswordPopup from "components/modal/PasswordPopup";
import AlertDialog from "../../../../components/Feedback/AlertDialog";
import {
  createAdmin,
  getAllAdmins,
} from "../../../../services/userServices/adminService";
import { getAllPositions } from "../../../../services/positionService";
import { getAllMemberStatus } from "../../../../services/memberStatusService";
import { getAllRoles } from "../../../../services/roleService";

const AddAdmin = () => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [generatedPassword, setGeneratedPassword] = useState("");

  const [jabatanOptions, setJabatanOptions] = useState([]);
  const [statusKeanggotaanOptions, setStatusKeanggotaanOptions] = useState([]);
  const [jenisPenggunaOptions, setJenisPenggunaOptions] = useState([]);
  const [usedEmployeeIds, setUsedEmployeeIds] = useState([]);
  const [isAlertOpen, setIsAlertOpen] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    control,
    //watch,
    getValues,
    formState: { errors },
  } = useForm();

  const generatePassword = () => {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    return Array.from(
      { length: 8 },
      () => chars[Math.floor(Math.random() * chars.length)]
    ).join("");
  };

  useEffect(() => {
    const newPassword = generatePassword();
    setGeneratedPassword(newPassword);
    setValue("password", newPassword);
    const fetchDropdownData = async () => {
      try {
        const positions = await getAllPositions();
        const filteredJabatan = positions
          .filter((item) => item.status?.toUpperCase() === "ADMIN")
          .map((item) => ({ value: item.id, label: item.name }));
        setJabatanOptions(filteredJabatan);

        const status = await getAllMemberStatus();
        const filteredStatus = status
          .filter((item) => item.status?.toUpperCase() === "ADMIN")
          .map((item) => ({ value: item.id, label: item.name }));
        setStatusKeanggotaanOptions(filteredStatus);

        const roles = await getAllRoles();
        const filteredRoles = roles
          .filter((item) => item.status?.toUpperCase() === "ADMIN")
          .map((item) => ({ value: item.id, label: item.name }));
        setJenisPenggunaOptions(filteredRoles);
      } catch (err) {
        console.error("Gagal memuat data dropdown:", err);
      }
    };
    const fetchUsedEmployeeIds = async () => {
      try {
        const users = await getAllAdmins();
        const aktif = users.filter(
          (u) => u.is_active && u.employees?.employee_id
        );
        const ids = aktif.map((u) => u.employees.employee_id);
        setUsedEmployeeIds(ids);
      } catch (error) {
        console.error("Gagal mengambil employee ID:", error);
      }
    };

    fetchUsedEmployeeIds();

    fetchDropdownData();
  }, [setValue]);

  const onSubmit = async (data) => {
    const kode = data.employee_id;

    try {
      const users = await getAllAdmins(); // Ambil ulang data untuk validasi
      const aktif = users.filter(
        (u) => u.is_active && u.employees?.employee_id
      );
      const used = aktif.map((u) => u.employees.employee_id);

      if (used.includes(kode)) {
        alert("Kode karyawan sudah digunakan. Silakan gunakan kode lain.");
        return;
      }

      const payload = {
        fullName: data.nama,
        email: data.email,
        password: data.password,
        phone: data.telp,
        positionId: data.jabatan,
        roleId: data.jenis,
        memberStatusId: data.status,
        employeeId: data.employee_id,
        joinDate: data.tanggalMasuk,
        address: data.alamat,
        userType: "ADMIN",
      };
      console.log(payload); // debug kalau mau lihat
      await createAdmin(payload);
      setShowPopup(true);
    } catch (err) {
      console.error("Gagal menambahkan user:", err);
      if (err.response) {
        console.error("Detail error response:", err.response.data);
      }
      alert("Terjadi kesalahan saat menyimpan data.");
    }
  };

  return (
    <div className="pl-64 mt-8">
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="max-w-4xl p-6 mx-auto bg-white border border-gray-200 shadow-lg rounded-2xl"
      >
        <h2 className="mb-6 text-xl font-semibold text-center text-green-700 sm:text-xl">
          Tambah Data Admin
        </h2>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {/* Kolom Kiri */}
          <div className="space-y-4">
            <InputField
              label="Nama Lengkap"
              name="nama"
              {...register("nama", { required: "Nama wajib diisi" })}
              error={errors.nama}
            />
            <InputField
              label="Email"
              name="email"
              type="email"
              {...register("email", {
                required: "Email wajib diisi",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Format email tidak valid",
                },
              })}
              error={errors.email}
            />
            <SelectField
              label="Jabatan"
              name="jabatan"
              control={control}
              options={jabatanOptions}
              rules={{ required: "Jabatan wajib dipilih" }}
              error={errors.jabatan}
            />
            <SelectField
              label="Jenis Pengguna"
              name="jenis"
              control={control}
              options={jenisPenggunaOptions}
              rules={{ required: "Jenis pengguna wajib dipilih" }}
              error={errors.jenis}
            />
            <TextAreaField
              label="Alamat"
              name="alamat"
              {...register("alamat", { required: "Alamat wajib diisi" })}
              error={errors.alamat}
            />
          </div>

          {/* Kolom Kanan */}
          <div className="space-y-4">
            <InputField
              label="No. Telp"
              name="telp"
              type="text"
              {...register("telp", {
                required: "No. Telp wajib diisi",
                pattern: {
                  value: /^[0-9]+$/,
                  message: "No. Telp hanya boleh angka",
                },
                minLength: {
                  value: 10,
                  message: "Minimal 10 digit",
                },
                maxLength: {
                  value: 13,
                  message: "Maksimal 13 digit",
                },
              })}
              error={errors.telp}
            />
            {/* <InputField
              label="Password"
              name="password"
              type="password"
              readOnly
              {...register("password")}
            /> */}
            <SelectField
              label="Status Keanggotaan"
              name="status"
              control={control}
              options={statusKeanggotaanOptions}
              rules={{ required: "Status wajib dipilih" }}
              error={errors.status}
            />
            <KodeKaryawanInput
              register={register}
              setValue={setValue}
              getValues={getValues}
              errors={errors}
              usedEmployeeIds={usedEmployeeIds}
            />

            <DateField
              label="Tanggal Masuk"
              name="tanggalMasuk"
              type="date"
              {...register("tanggalMasuk", {
                required: "Tanggal Masuk wajib diisi",
              })}
              error={errors.tanggalMasuk}
            />
          </div>
        </div>

        <FormActionButtons
          submitLabel="Simpan"
          cancelLabel="Batal"
          onCancel={() => navigate("/data-admin")}
          className="mt-8"
        />

        {showPopup && (
          <PasswordPopup
            password={generatedPassword}
            onClose={() => {
              setShowPopup(false);
              setIsAlertOpen(true);
            }}
          />
        )}
        {isAlertOpen && (
          <AlertDialog
            isOpen={isAlertOpen}
            onClose={() => {
              setIsAlertOpen(false);
              navigate("/data-admin"); // pindah ke halaman DataAdmin setelah alert auto-close
            }}
            title="Berhasil"
            message="Admin berhasil ditambahkan!"
          />
        )}
      </form>
    </div>
  );
};

export default AddAdmin;
